import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { MemberWallet, MemberPaymentBalance } from './type';

/**
 * C端会员余额
  GET /balance/api/wallet/detail
  接口ID：244544748
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-244544748
 */
export const getMemberWallet = (): AxiosPromise<MemberWallet> => {
  return request({
    url: '/balance/api/wallet/detail',
    method: 'get'
  });
};

/**
 * C端会员支付可用余额
  GET /balance/api/wallet/payment/balance
  接口ID：252588352
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-252588352
 */
export const getMemberPayment = (params: MemberPaymentBalance): AxiosPromise<MemberPaymentBalance> => {
  return request({
    url: '/balance/api/wallet/payment/balance',
    method: 'get',
    params
  });
};
